<template>
  <div>
    <el-form :model="loginForm" :rules="formRules" ref="loginForm" label-position="left" label-width="0px"
             @keyup.enter.native="handleLogin" class="login-container">
      <h1 class="title-h1">广东为众六类场所电气防火安全检测数据综合管理系统</h1>
      <el-form-item prop="account">
        <el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="btn-login" type="danger" @click.native.prevent="handleLogin" :loading="logining">登陆
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logining: false,
      loginForm: {
        account: '',
        password: ''
      },
      formRules: {
        account: [{required: true, message: '请输入账号', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}]
      },
      checked: true
    }
  },
  methods: {
    async handleLogin() {
      try {
        let params = {
          account: this.loginForm.account,
          password: this.loginForm.password
        }
        let data = await this.$Api.post('login', params)
        await this.$store.dispatch('initUserinfo', data)
        await this.$store.dispatch('initPermission')
        this.$notify({
          title: '成功',
          message: '登录成功',
          type: 'success',
          duration: 1000
        })
        this.$router.push({name: 'home'})
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  .title-h1 {
    text-align: center;
    margin-top: 0;
    color: var(--primary-color);
  }

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
    font-size: 20px;
  }
}

.beian {
  margin: 20px auto;
  width: 400px;
  height: 100px;
}

.btn-login {
  width: 100%;
  background: var(--primary-color);
  border-color: var(--primary-color);
}
</style>
